import { render, staticRenderFns } from "./SimpleExamModelChangeActivationType.vue?vue&type=template&id=130b48de&"
import script from "./SimpleExamModelChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./SimpleExamModelChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports